import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Image } from "react-bootstrap";
import logo from "../../assets/images/finpedia-logo.svg";
import Dashborad from "../../assets/images/sidebar-icons/dashborad-icon.svg";
import calendar2 from "../../assets/images/sidebar-icons/calendar2-icon.svg";
import element2 from "../../assets/images/sidebar-icons/element2.svg";
import event2 from "../../assets/images/sidebar-icons/event-icon.svg";
import { useLocation } from "react-router-dom";
import { loginApi } from "../login/Api";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import _ from "lodash";

const remove = [30, 29, 25, 24, 11, 46, 52];

const Sidebar = ({ loginState }) => {
  const modules = JSON.parse(localStorage.getItem("finAdmin"))?.modules || [];
  const groupByGroup = _.groupBy(modules, "group");

  // Add Dashboard to GENERAL group
  if (groupByGroup["GENERAL"]) {
    groupByGroup["GENERAL"].unshift({
      moduleName: "Dashboard",
      moduleUrl: "/dashboard",
      moduleIcon: element2,
      activeIcon: Dashborad,
      subModuleName: "Dashboard",
      group: "GENERAL",
      sortIndex: -1,
      id: 0,
    });
  }

  const location = useLocation();
  const [active, setActive] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogoClick = () => {
    setIsCollapsed(!isCollapsed);
    if (!isCollapsed) {
      setActive(null);
    }
  };

  useEffect(() => {
    // Set active based on current pathname — must mirror the render loop's
    // filtering / sorting / grouping so the generated uniqueKey matches.
    const currentPath = location.pathname;
    let foundActive = false;

    Object.entries(groupByGroup).forEach(([groupName, groupModules]) => {
      const filteredGroupModules = getFilteredModules(groupModules);
      const sortedGroupModules = filteredGroupModules.sort(
        (a, b) => (a.sortIndex || 0) - (b.sortIndex || 0)
      );
      const groupedByName = _.groupBy(sortedGroupModules, "moduleName");

      const sortedEntries = Object.entries(groupedByName).sort(
        ([nameA, itemsA], [nameB, itemsB]) => {
          if (nameA === "Dashboard") return -1;
          if (nameB === "Dashboard") return 1;
          return (itemsA[0]?.sortIndex || 0) - (itemsB[0]?.sortIndex || 0);
        }
      );

      sortedEntries.forEach(([moduleName, moduleItems], moduleIndex) => {
        const filteredModuleItems = getFilteredModules(moduleItems);
        const hasMatch = filteredModuleItems.some(
          (m) => m.moduleUrl === currentPath
        );
        if (hasMatch) {
          setActive(`${groupName}-${moduleName}-${moduleIndex}`);
          foundActive = true;
        }
      });
    });

    if (!foundActive) {
      setActive(null);
    }
  }, [location.pathname]);

  const handleModuleClick = (val) => {
    if (isCollapsed) {
      setIsCollapsed(false);
      setTimeout(() => setActive(active === val ? null : val), 50);
    } else {
      setActive(active === val ? null : val);
    }
  };

  // Helper function to check if a module should be rendered as dropdown or single link
  const shouldRenderAsDropdown = (moduleItems) => {
    return moduleItems.length > 1 ||
      (moduleItems.length === 1 && moduleItems[0].moduleUrl === "#");
  };

  // Helper function to get filtered modules (excluding removed IDs)
  const getFilteredModules = (modules) => {
    return modules.filter(module => !remove.includes(module.id));
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Fixed Logo Section */}
      <div className="logo" onClick={handleLogoClick}>
        {!isCollapsed ? (
          <img className="pointer" src={logo} alt="Finpedia Logo" />
        ) : (
          <img className="pointer" src={"/android-chrome-512x512.png"} alt="Finpedia Favicon" />
        )}
      </div>

      <div className="sidebar-nav">
        {Object.entries(groupByGroup)
          .sort(([groupNameA], [groupNameB]) => {
            if (groupNameA === "GENERAL") return -1;
            if (groupNameB === "GENERAL") return 1;
            return groupNameA.localeCompare(groupNameB);
          })
          .map(([groupName, groupModules], groupIndex) => {
            const filteredGroupModules = getFilteredModules(groupModules);
            if (filteredGroupModules.length === 0) return null;

            const sortedGroupModules = filteredGroupModules.sort((a, b) => (a.sortIndex || 0) - (b.sortIndex || 0));
            const groupByModuleName = _.groupBy(sortedGroupModules, "moduleName");

            // Sort the module entries to ensure Dashboard is first
            const sortedModuleEntries = Object.entries(groupByModuleName).sort(([moduleNameA, itemsA], [moduleNameB, itemsB]) => {
              // Force Dashboard to always be first
              if (moduleNameA === "Dashboard") return -1;
              if (moduleNameB === "Dashboard") return 1;

              // For other modules, use the sortIndex from the first item
              const sortIndexA = itemsA[0]?.sortIndex || 0;
              const sortIndexB = itemsB[0]?.sortIndex || 0;
              return sortIndexA - sortIndexB;
            });

            return (
              <div key={groupIndex} className="sidebar-group">
                {!isCollapsed && (
                  <p className="module-group-title f-s-12 inter-regular">{groupName}</p>
                )}

                {sortedModuleEntries.map(([moduleName, moduleItems], moduleIndex) => {
                  const filteredModuleItems = getFilteredModules(moduleItems);
                  if (filteredModuleItems.length === 0) return null;

                  const uniqueKey = `${groupName}-${moduleName}-${moduleIndex}`;
                  const isDropdown = shouldRenderAsDropdown(filteredModuleItems);
                  const isOpen = active === uniqueKey;

                  if (isDropdown) {
                    const firstItem = filteredModuleItems[0];

                    return (
                      <div key={uniqueKey} className="side-nav-custom-dropdown" title={firstItem?.moduleName}>
                        <div
                          className="dropdown-header"
                          onClick={(e) =>{
                            e.stopPropagation();
                             handleModuleClick(uniqueKey)}}
                        >
                          <a className="route-name">
                            <Image
                              src={firstItem?.moduleIcon || event2}
                              className="profile main"
                            />
                            {!isCollapsed && (
                              <>
                                <span>{firstItem?.moduleName || "Na"}</span>
                                <div className="custom-arrow"></div>
                              </>
                            )}
                          </a>
                        </div>
                        {!isCollapsed && (
                          <div className={`dropdown-body ${isOpen ? "open" : ""}`}>
                            <div className="dropdown-body-inner">
                              {filteredModuleItems.map((subItem, subIndex) => {
                                return (
                                  <NavLink
                                    key={subIndex}
                                    to={subItem.moduleUrl || "#"}
                                    end
                                    className={({ isActive }) =>
                                      `route-name d-flex align-items-center${isActive ? " active" : ""}`
                                    }
                                    title={subItem.subModuleName || subItem.moduleName || "Na"}
                                    onClick={() => setActive(uniqueKey)}
                                  >
                                    {({ isActive }) => (
                                      <>
                                        <div style={{
                                          backgroundColor: isActive ? "#ffffff" : "#808080",
                                          width: "0.8rem",
                                          height: "0.8rem",
                                          borderRadius: "50%",
                                          flexShrink: 0,
                                        }} />
                                        <span>{subItem.subModuleName || subItem.moduleName || "Na"}</span>
                                      </>
                                    )}
                                  </NavLink>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    // Single module item
                    const singleItem = filteredModuleItems[0];

                    return (
                      <NavLink
                        key={uniqueKey}
                        to={singleItem.moduleUrl || "#"}
                        end
                        className={({ isActive }) =>
                          `route-name${isActive ? " active" : ""}`
                        }
                        title={singleItem?.moduleName}
                        onClick={() => setActive(uniqueKey)}
                      >
                        {({ isActive }) => (
                          <>
                            <Image
                              src={isActive ? (singleItem.activeIcon || calendar2) : (singleItem.moduleIcon || event2)}
                              className="profile main"
                            />
                            {!isCollapsed && <span>{singleItem.subModuleName || singleItem.moduleName || "Na"}</span>}
                          </>
                        )}
                      </NavLink>
                    );
                  }
                })}
              </div>
            );
          })}
      </div>

      <div
        className={"logout-section" + (isCollapsed ? " collaspe" : "")}
        onClick={() => {
          localStorage.removeItem("finAdmin");
          window.location.href = "/";
        }}
      >
        <span className="me-2">{logoutIcon}</span>
        {!isCollapsed && <span className="red-FB2 f-s-16">Logout</span>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loginState: state.LoginState,
});

const mapDispatchToProps = {
  loginApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));

export const logoutIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.50122 5.83341C7.51131 4.02089 7.59169 3.0393 8.232 2.39898C8.96426 1.66675 10.1428 1.66675 12.4998 1.66675H13.3331C15.6901 1.66675 16.8687 1.66675 17.6008 2.39898C18.3331 3.13121 18.3331 4.30972 18.3331 6.66675V13.3334C18.3331 15.6904 18.3331 16.8689 17.6008 17.6012C16.8687 18.3334 15.6901 18.3334 13.3331 18.3334H12.4998C10.1428 18.3334 8.96426 18.3334 8.232 17.6012C7.59169 16.9608 7.51131 15.9792 7.50122 14.1667" stroke="#FB2C36" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M12.5001 10H1.66675M1.66675 10L4.58341 7.5M1.66675 10L4.58341 12.5" stroke="#FB2C36" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);